import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import VueTheMask from "vue-the-mask";
import vueHeadful from "vue-headful";
import store from './store'
import number from './number'

Vue.use(VueTheMask);
Vue.use(number)

Vue.component("vue-headful", vueHeadful);

Vue.config.productionTip = false
Vue.prototype.$clienteNome = process.env.VUE_APP_CLIENTE;
Vue.prototype.$clienteNomeFantasia = process.env.VUE_APP_CLIENTE_FANTASIA;
Vue.prototype.$mostraLogoBarra = process.env.VUE_APP_MOSTRA_LOGO_BARRA;
Vue.prototype.$mostraLogoLogin = process.env.VUE_APP_MOSTRA_LOGO_LOGIN;
Vue.prototype.$mostraFrasePCD = process.env.VUE_APP_MOSTRA_FRASE_PCD;
Vue.prototype.$mostraBotaoVagas = process.env.VUE_APP_MOSTRA_BOTAO_VAGAS;
Vue.prototype.$recuperacaoSenhaSMS = process.env.VUE_APP_RECUPERACAO_SENHA_SMS == 'TRUE' ? true : false;
Vue.prototype.$logId = process.env.VUE_APP_LOG_ID;
Vue.prototype.$segundosSessao = process.env.VUE_APP_SEGUNDOS_SESSAO;
Vue.prototype.$segundosSessao = process.env.VUE_APP_SEGUNDOS_SESSAO;
Vue.prototype.$mostraTempoBarra = process.env.VUE_APP_MOSTRA_TEMPO_BARRA == 'TRUE' ? true : false;
Vue.prototype.$pretensaoSalarialObrigatoria = process.env.VUE_APP_PRETENSAO_SALARIAL_OBRIGATORIA == 'TRUE' ? true : false;
Vue.prototype.$mostrarDadosCNH = process.env.VUE_APP_MOSTRAR_DADOS_CNH == 'TRUE' ? true : false;
Vue.prototype.$msgEsquecimentoSenha = process.env.VUE_APP_MSG_ESQUECIMENTO_SENHA;
Vue.prototype.$avisoHomeTitulo = process.env.VUE_APP_AVISO_HOME_TITULO;
Vue.prototype.$avisoHomeConteudo = process.env.VUE_APP_AVISO_HOME_CONTEUDO.split('|');
Vue.prototype.$emManutencao = process.env.VUE_APP_EM_MANUTENCAO == 'TRUE' ? true : false;
Vue.prototype.$msgManutencao = process.env.VUE_APP_MSG_MANUTENCAO;
Vue.prototype.$obrigaRG = process.env.VUE_APP_OBRIGA_RG == 'TRUE' ? true : false;
Vue.prototype.$obrigaCNH = process.env.VUE_APP_OBRIGA_CNH == 'TRUE' ? true : false;
Vue.prototype.$obrigaEmail = process.env.VUE_APP_OBRIGA_EMAIL == 'TRUE' ? true : false;
Vue.prototype.$obrigaCelular = process.env.VUE_APP_OBRIGA_CELULAR == 'TRUE' ? true : false;
Vue.prototype.$obrigaFiliacao = process.env.VUE_APP_OBRIGA_FILIACAO == 'TRUE' ? true : false;
Vue.prototype.$codEmp = Number(process.env.VUE_APP_COD_EMP);
Vue.prototype.$obrigaAreaInteresse = process.env.VUE_APP_OBRIGA_AREAINTERESSE == 'TRUE' ? true : false;

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')